import React, { Component, ReactNode } from "react"
import { Grid, Typography, Hidden, Box } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import clsx from "clsx"

import { NavigationBar, MobileTopBar, MobileBottomBar } from "../navigation"
import SEO from "components/seo"
import { MobileDrawer, useMenuState } from "components/mobile-drawer"
import { CityMobileTemplate } from "components/city/city-mobile-template"

const useStyles = makeStyles(() => ({
  root: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },

  main: {
    marginLeft: ({ fullWidth }) => (fullWidth ? undefined : "auto"),
    marginRight: ({ fullWidth }) => (fullWidth ? undefined : "auto"),
    maxWidth: ({ fullWidth }) => (fullWidth ? undefined : 950),
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: ({ centered }: Props) =>
      centered ? "center" : "flex-start",
    flexGrow: 3,
  },
  footer: {
    padding: "1.0875rem 0px",
    textAlign: "center",
  },
  fullWidth: {
    width: "100%",
  },
  white: {
    backgroundColor: "white",
  },
  container: {
    width: "inherit",
    margin: "unset",
  },
  narrow: {
    // wide text looks bad
    maxWidth: 700,
  },
  title: {
    textTransform: "uppercase",
    fontWeight: "bold",
  },
  cityContainer: {
    width: "100%",
    height: "100%",
    overflow: "hidden",
    position: "absolute",
    zIndex: -1000,
    opacity: 0.08,
  },
}))

interface Props {
  pageName: string
  children?: Component | JSX.Element | Array<JSX.Element>
  withCity?: boolean
  centered?: boolean
  pageTitle?: string
  white?: boolean
  narrow?: boolean
  fullWidth?: boolean
  headerChildren?: ReactNode
}

export const Layout = (props: Props) => {
  const {
    children,
    headerChildren,
    pageName,
    pageTitle,
    white,
    narrow,
    withCity = true,
  } = props
  const classes = useStyles(props)
  const { isMenuOpen, closeMenu, toggleMenu } = useMenuState()

  return (
    <div className={clsx(classes.root, { [classes.white]: white })}>
      {withCity && (
        <div className={classes.cityContainer}>
          <CityMobileTemplate height={"100%"} />
        </div>
      )}
      <Hidden smDown implementation="css">
        <Grid item xs className={classes.fullWidth}>
          <NavigationBar transparent />
        </Grid>
      </Hidden>
      <Hidden mdUp implementation="css">
        <MobileTopBar>{headerChildren}</MobileTopBar>
        <MobileDrawer isMenuOpen={isMenuOpen} onClose={closeMenu} />
        <MobileBottomBar onToggleMenu={toggleMenu} fixed />
      </Hidden>
      <SEO title={pageName} />
      <main className={clsx(classes.main, { [classes.narrow]: narrow })}>
        {pageTitle && (
          <Box pt={2} pb={4} textAlign="center">
            <Typography className={classes.title} variant="h4">
              {pageTitle}
            </Typography>
          </Box>
        )}
        {children}
      </main>
      <footer className={classes.footer}>
        © GMD {new Date().getFullYear()}
      </footer>
      <Hidden mdUp>
        <Box pb={1}>&nbsp;</Box>
      </Hidden>
    </div>
  )
}
